export default __webpack_public_path__ + "static/media/TF2-1.ce0cb91f.jpg";